export default __webpack_public_path__ + "img/sidebar_activity.cd857e27.svg";